import React from 'react'
import { cleanLabel } from '@helpers/global'

interface SwatchProps {
  value: any
  isSelected: boolean
  onClick: () => void
  swatchAppearance: string
}

const Swatch: React.FC<SwatchProps> = ({ value, isSelected, onClick, swatchAppearance }) => {
  const { label, swatch } = value
  const hasImage = Boolean(swatch.image)

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  const sharedStyles = {
    backgroundImage: hasImage ? `url(${swatch.image})` : 'none',
    backgroundColor: hasImage ? 'transparent' : swatch.color,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: 'inset 0 -15px 4px rgba(0, 0, 0, 0.11)',
  }

  const CheckboxAppearance = () => (
    <div
      className="flex items-center space-x-2 cursor-pointer"
      role="button"
      tabIndex={0}
      aria-label={`Filter by ${label}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        className="w-4.5 h-4.5 cursor-pointer rounded-sm bg-gradient-model-grey shadow-thumbnail"
      />
      <div
        className="w-5 h-5 rounded-full border border-blue-1 shadow-thumbnail"
        style={sharedStyles}
      />
      <span className="ml-2 body-xs font-medium text-black">
        {cleanLabel(label)}
      </span>
    </div>
  )

  const DefaultAppearance = () => (
    <div
      className={`w-8 h-8 cursor-pointer rounded-sm border border-blue-1 shadow-thumbnail ${
        isSelected ? 'outline outline-2 outline-offset-2 outline-blue-2' : ''
      }`}
      style={sharedStyles}
      role="button"
      tabIndex={0}
      aria-label={`Filter by ${label}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    />
  )

  return swatchAppearance === 'swatch-checkbox' ? <CheckboxAppearance /> : <DefaultAppearance />
}

export default Swatch
